export { DesktopView } from './DesktopView';
export { MobileView } from './MobileView';

export const SEARCH_PSYCHOLOGISTS_KEY_PREFIX =
  'AppointmentsReserve.SearchPsychologist.Steps.Psychologist.';
